"use client";

import React, { useEffect, useState } from "react";
import { 
  Box, 
  Fade, 
  Breadcrumb, 
  BreadcrumbItem, 
  BreadcrumbLink,
  Container
} from "@chakra-ui/react";
import { useParams, useNavigate, Link, useLocation } from "react-router-dom";
import { ChevronRightIcon } from "@chakra-ui/icons";
import SalesExecutiveProfile from "../components/salesexecutive/SalesExecutiveProfile";
import { getBusinessIdentifier } from "../utils/auth";

const SalesExecutiveProfilePage: React.FC = () => {
  const params = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  
  // Get name and email from URL search params
  const searchParams = new URLSearchParams(location.search);
  const executiveName = searchParams.get('name') || '';
  const executiveEmail = searchParams.get('email') || '';
  // Make sure we're getting the ID properly from the URL params
  const executiveId = params.id ;
  // const executiveId = searchParams.get('executiveId') || '';
  const businessId = getBusinessIdentifier();
  
  useEffect(() => {
    // Trigger page fade animation
    setIsLoaded(true);
  }, [executiveId, executiveName, executiveEmail]);
  
  const handleClose = () => {
    navigate('/sales-team');
  };

  return (
    <Fade 
      in={isLoaded} 
      transition={{ enter: { duration: 0.3 } }}
    >
      <Box height="100%" width="100%" bg="gray.50">
        <Container maxW="container.xl" pt={4}>
          <Breadcrumb spacing='8px' separator={<ChevronRightIcon color='gray.500' />} mb={4}>
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/dashboard" fontSize="sm" color="gray.600">
                Dashboard
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem>
              <BreadcrumbLink as={Link} to="/sales-team" fontSize="sm" color="gray.600">
                Sales Team
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink fontSize="sm" color="blue.600" fontWeight="medium">
                Sales Executive
              </BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>
        </Container>
        <SalesExecutiveProfile 
          executiveId={executiveId} 
          onClose={handleClose} 
          executiveName={executiveName}
          executiveEmail={executiveEmail}
          businessId={businessId || "default_business_id_placeholder"}
        />
      </Box>
    </Fade>
  );
};

export default SalesExecutiveProfilePage; 